module.exports = __webpack_public_path__ + "img/NZ.30299530.svg";